import React, { FC, ReactElement } from 'react'
import { Box, List, Heading, Text } from 'grommet'
import { Link } from 'gatsby'
import { useLayoutConfig, FacilitiesI } from '../../custom-hooks/useLayoutConfig'
import Icons from '../icons/Icons'
import './facilities-preview.scss'

interface PreviewListPropsI {
  list: FacilitiesI[]
}

const PreviewList: FC<PreviewListPropsI> = ({ list }: PreviewListPropsI) => (
  <List data={list} className="facilities-list-container" border="vertical">
    {(item: FacilitiesI): ReactElement<typeof Box> => (
      <Box margin={{ bottom: 'small' }} align="center">
        <Icons name={item.iconName} />
        <Text>{item.label}</Text>
      </Box>
    )}
  </List>
)

const FacilitiesPreview: FC = () => {
  const layoutConfig = useLayoutConfig()

  return (
    <Box margin={{ vertical: 'large', horizontal: 'medium' }}>
      <Box align="center">
        <Heading level={2} size="medium">
          Why book with us?
        </Heading>
      </Box>
      <Box align="end">
        <Link to={'/facilities'}>
          <Text>View All Facilities</Text>
        </Link>
      </Box>
      <Box margin={{ top: 'large' }}>
        <PreviewList list={layoutConfig.facilitiesPreview.slice(0, 5)} />
      </Box>
    </Box>
  )
}

export default FacilitiesPreview
